import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import MatchAccaSelectionItem from 'modules/match-acca/match-acca-selection-item/index.jsx';
import BetslipModuleUtils from 'modules/betslip/utils.js';
import SelectionButton from 'modules/selection-button/index.jsx';
import SelectionsContext from 'modules/selection-button/context/selections-context.js';
import PrebuiltBetSelectionsContext from 'modules/prebuilt-bets/prebuilt-bet/context/prebuilt-bet-selections-context.js';

import { useMemo, memo } from 'react';

const { FlexPane, AbsolutePane, Image, Button } = MojitoPresentation.Components;
const { types: BetslipTypes } = MojitoServices.Betslip;

// eslint-disable-next-line react/display-name
const PrebuiltBet = memo(props => {
    const {
        mojitoTools: { config, l10n },
        event,
        market,
        onEventClick,
        isSameBetMarket,
        children,
    } = props;

    const selection = market?.selections[0];
    const parts = market?.preBuiltBetBuilderParts;
    const selectionsContext = useMemo(
        () => new PrebuiltBetSelectionsContext(market, event?.canonicalName),
        [market, event]
    );

    const sportImage = config.sportIcons[event?.sportId] || config.sportIcons.defaultIcon;

    if (!market || !event || !selection) {
        return null;
    }

    return (
        <FlexPane class="ta-PrebuiltBet" config={config.genericEventCard.container}>
            {config.showBackgroundSportImage && (
                <BackgroundSportImage {...props} image={sportImage} />
            )}
            <Button
                onClick={onEventClick}
                disabled={!config.showCardHeader || !config.cardClickable}
                config={config.genericEventCard.clickableArea}
            >
                {children}
                <FlexPane config={config.matchAccaSelectionsContainer}>
                    <MatchAccaSelections
                        parts={parts}
                        isSameBetMarket={isSameBetMarket}
                        l10n={l10n}
                        suspendedParts={[]}
                        config={config.matchAccaSelectionItem}
                    />
                </FlexPane>
            </Button>
            <SelectionsContext.Provider value={selectionsContext}>
                <SelectionContent {...props} event={event} market={market} selection={selection} />
            </SelectionsContext.Provider>
        </FlexPane>
    );
});

const SelectionContent = props => {
    const { event, market = {}, selection, mojitoTools } = props;
    if (!selection) {
        return null;
    }
    const { config } = mojitoTools;
    return (
        <FlexPane config={config.selectionContentContainer}>
            <SelectionButton
                config={config.selectionButton}
                selection={selection}
                event={event}
                marketStatus={market.status}
                marketType={market.type}
                marketId={market.id}
                bettingContext={BetslipTypes.BETTING_CONTEXT.PRE_BUILT_BET}
            />
        </FlexPane>
    );
};

const BackgroundSportImage = props => {
    const { mojitoTools, image } = props;
    const { config } = mojitoTools;
    return (
        <AbsolutePane config={config.genericBackgroundImageContainer}>
            <Image src={image} config={config.genericBackgroundSportImage} />
        </AbsolutePane>
    );
};

const MatchAccaSelections = ({ parts, isSameBetMarket, l10n, config }) =>
    parts.map((part, i, row) => {
        const showSeparator = i + 1 !== row.length;
        const selectionLabel = BetslipModuleUtils.resolveNameAndHandicapLabel(part, l10n);

        return (
            <MatchAccaSelectionItem
                config={config}
                key={`${part.marketName}-${part.selectionName}-${part.eventName}`}
                showSeparator={showSeparator}
                selectionLabel={selectionLabel}
                marketName={part.marketName}
                eventName={part.eventName}
                isSameBetMarket={isSameBetMarket}
            />
        );
    });

export default PrebuiltBet;
